module.exports = __webpack_public_path__ + "img/bg_09@2x.316bea4e.jpg";